import { Base } from '@akiba/models_bimbo';

export class AppState extends Base {

    tabIndex: number;
    contentIndex: number;
    detailIndex: number;
    savingParametersIndex: number;

    constructor(data: any | null = null) {

        super();
        this.tabIndex = 0;
        this.contentIndex = 0;
        this.detailIndex = 0;
        this.savingParametersIndex = 0;
        this.load(data);

    }

    fromString(data: string = null) {

        if (data) {
            const dataObj = JSON.parse(data);
            this.load(dataObj);
        }

    }

    toString(): string {

        return JSON.stringify(this);

    }

}
